/**
 * Dependencies.
 */
import { authService } from '@prz-dp/services';
import { NavigationGuardNext, Route, RouteConfig } from 'vue-router';

import { orderRequestService } from '@/api/order-request/order-request.service';
import ChangeAddress from '@/modules/tracking/scenes/address/change/change-address.scene.vue';
import OutOfRange from '@/modules/tracking/scenes/address/out-of-range/out-of-range.scene.vue';
import SearchAddress from '@/modules/tracking/scenes/address/search/search-address.scene.vue';
import RequestMessageChat from '@/modules/tracking/scenes/chat/request-message-chat.scene.vue';
import ChooseAddressDay from '@/modules/tracking/scenes/choose-address-day/choose-address-day.scene.vue';
import ConfirmChange from '@/modules/tracking/scenes/confirm/confirm-change.scene.vue';
// import RequestContact from '@/modules/tracking/scenes/contact/request-contact.scene.vue';
import RequestCancel from '@/modules/tracking/scenes/request-cancel/request-cancel.scene.vue';
import PickUpCode from '@/modules/tracking/scenes/service-point/pick-up-code/pick-up-code.scene.vue';
import PickUpConfirm from '@/modules/tracking/scenes/service-point/pick-up-confirm/pick-up-confirm.scene.vue';
import PickUpList from '@/modules/tracking/scenes/service-point/pick-up-list/pick-up-list.scene.vue';
import TrackingScene from '@/modules/tracking/scenes/tracking/tracking.scene.vue';

/**
 * Route meta data.
 */
const meta = {
  requiresAuth: true
};

/**
 * Routes.
 */
export default [
  // Tracking public route.
  {
    component: TrackingScene,
    name: 'Tracking',
    path: 't/:key'
  },
  // Survey private route from tracking.
  {
    beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext) => {
      let canGoNext = false;

      const { params = null } = to || {};
      const { key = null } = params || {};

      try {
        const {
          result: isValidUser = false
        } = await orderRequestService.validateUser(key);

        canGoNext = isValidUser;
      } catch (error) {
        canGoNext = false;
      }

      if (canGoNext) {
        next({
          name: 'SurveyStep1',
          params: {
            key
          }
        });
      } else {
        next(false);

        await authService.logout({
          redirectUri: `${window.location.origin}/unauthorized`
        });
      }
    },
    meta,
    name: 'TrackingSurvey',
    path: 't/:key/survey'
  },
  // Request contact route.
  /*
  {
    component: RequestContact,
    meta,
    name: 'RequestContact',
    path: 't/:key/request/contact'
  },
  */
  // Request message chat route.
  {
    component: RequestMessageChat,
    meta,
    name: 'RequestMessageChat',
    path: 't/:key/request/message/chat'
  },
  // Choose change address or day route.
  {
    component: ChooseAddressDay,
    meta,
    name: 'RequestChooseChange',
    path: 't/:key/request/choose-change'
  },
  // Search address route.
  {
    component: SearchAddress,
    meta,
    name: 'SearchAddress',
    path: 't/:key/address/search'
  },
  // Search out of range route.
  {
    component: OutOfRange,
    meta,
    name: 'OutOfRange',
    path: 't/:key/out-of-range'
  },
  // Change address route.
  {
    component: ChangeAddress,
    meta,
    name: 'ChangeAddress',
    path: 't/:key/address/change'
  },
  // Confirm change route.
  {
    component: ConfirmChange,
    meta,
    name: 'ConfirmChange',
    path: 't/:key/confirm/change/:type'
  },
  // Cancel request route.
  {
    component: RequestCancel,
    meta,
    name: 'RequestCancel',
    path: 't/:key/request/cancel/:type'
  },
  // Pick up code route.
  {
    component: PickUpCode,
    meta,
    name: 'PickUpCode',
    path: 't/:key/pick-up/code'
  },
  // Pick up list route.
  {
    component: PickUpList,
    meta,
    name: 'PickUpList',
    path: 't/:key/pick-up/list'
  },
  // Pick up confirm route.
  {
    component: PickUpConfirm,
    meta,
    name: 'PickUpConfirm',
    path: 't/:key/pick-up/confirm'
  }
] as RouteConfig[];
